function numberOrNull(value) {
  if (value == null || value === '') return null;
  const numeric = typeof value === 'number'
    ? value
    : Number(String(value).replace(/,/g, ''));
  return Number.isFinite(numeric) ? numeric : null;
}

export function normalizeProductionComparisonRows(payload) {
  const rows = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
      ? payload.data
      : [];

  return rows
    .map((row) => {
      const predicted = numberOrNull(
        row?.predicted
        ?? row?.right
        ?? row?.['PVsyst Energy at POI MWh Total']
        ?? row?.['PVsyst Energy at POI MWh Cumulative'],
      );
      return {
        date: row?.date ?? row?.Date ?? '',
        actual: numberOrNull(
          row?.actual
          ?? row?.left
          ?? row?.['ACTUAL REC MWh Total']
          ?? row?.['ACTUAL REC MWh Cumulative'],
        ),
        // dbt emits zero when no PVsyst seed row exists. It is missing data,
        // not a zero-energy forecast.
        predicted: predicted === 0 ? null : predicted,
      };
    })
    .filter((row) => row.date);
}
